import {
  SET_CONTENT_LAYOUT,
  CONTENT_LAYOUT_GRID,
  CONTENT_LAYOUT_LIST
} from './types'

export const state = {
  layout: CONTENT_LAYOUT_GRID
}

export const mutations = {
  [SET_CONTENT_LAYOUT] (state, value) {
    state.layout = value
  }
}

export const actions = {
  contentLayoutGridView ({ commit }) {
    commit(SET_CONTENT_LAYOUT, CONTENT_LAYOUT_GRID)
  },
  contentLayoutListView ({ commit }) {
    commit(SET_CONTENT_LAYOUT, CONTENT_LAYOUT_LIST)
  }
}

export const getters = {
  isGridLayout ({ layout }) {
    return layout === CONTENT_LAYOUT_GRID
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/contents/contentLayout.js